import { render, staticRenderFns } from "./SalesStatisticsPage.vue?vue&type=template&id=31b70e67&"
import script from "./SalesStatisticsPage.vue?vue&type=script&lang=js&"
export * from "./SalesStatisticsPage.vue?vue&type=script&lang=js&"
import style0 from "./SalesStatisticsPage.vue?vue&type=style&index=0&id=31b70e67&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports